export default "__VITE_PUBLIC_ASSET__6e47fef4__"